window.gwpCurrentCallback = null;

var fetchConfig = (type = 'json') => {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

async function checkGWP(cart, callback = null, callbackOnlyOnSuccess = false) {
  const {
    giftVariantIds, 
    giftForcedVariantId, 
    giftProductId, 
    giftEnable, 
    giftProductAvailable, 
    minCartPrice, 
    eligibleProductIds, 
    eligibleProductType, 
    onePerEligible, 
    giftQuantity, 
    tandems } = window.shop.giftWithPurchase;
  const asyncCart = cart ? cart : await getCart();
  const isRemoved = sessionStorage.getItem('gwp') === 'removed';
  const totalGiftQuantity = asyncCart.items?.reduce((sum, { variant_id, quantity }) => giftVariantIds.includes(variant_id) ? sum + quantity : sum, 0);
  const hasFreeGift = asyncCart.items?.find((item) => giftVariantIds.includes(item.variant_id) && item.properties._isGWP);

  // ---------- tandem logic ----------
  const tandemsList = (window.shop?.giftWithPurchase?.tandems || [])
    .map(t => ({
      id: Number(t?.id),
      items: (t?.items || []).map(x => Number(x)).filter(Boolean) // drop null/NaN
    }))
    .filter(t => t.items.length > 0);

  const cartProductQty = asyncCart.items?.reduce((map, line) => {
    const pid = Number(line?.product_id);
    if (!pid) return map;
    map.set(pid, (map.get(pid) || 0) + (line?.quantity || 0));
    return map;
  }, new Map()) || new Map();

  // Build Map<pid, qty> for an items array (handles duplicates/qty requirements)
  const countOccurrences = (arr) => {
    const m = new Map();
    for (const pid of arr) m.set(pid, (m.get(pid) || 0) + 1);
    return m;
  };

  // TRUE if cart meets all required quantities for this tandem
  const hasAllItemsForTandem = (items) => {
    const req = countOccurrences(items);
    for (const [pid, need] of req) {
      if ((cartProductQty.get(pid) || 0) < need) return false;
    }
    return true;
  };

  // How many times this tandem can be satisfied given cart quantities
  const tandemMultiplier = (items) => {
    const req = countOccurrences(items);
    let maxTimes = Infinity;
    for (const [pid, need] of req) {
      const have = cartProductQty.get(pid) || 0;
      maxTimes = Math.min(maxTimes, Math.floor(have / need));
    }
    return Number.isFinite(maxTimes) ? maxTimes : 0;
  };

  // Rebuild your eligible list using the corrected logic
  const eligibleTandems = tandemsList
    .map(t => ({ ...t, multiplier: tandemMultiplier(t.items) }))
    .filter(t => t.multiplier > 0);

  // Number of distinct tandems satisfied at least once
  const tandemCount = eligibleTandems.length;

  // Total number of gifts unlocked if each tandem completion yields one gift
  let eligibleProductCount = eligibleTandems.reduce((sum, t) => sum + t.multiplier, 0);

  console.log('eligibleProductCount', eligibleProductCount);
  
  const GWPPopup = document.querySelector('gwp-popup');
  
  let isEligible;

  if (eligibleProductIds === 'all-products') {
    isEligible = (item) => !giftVariantIds.includes(item.variant_id) &&
      (
        eligibleProductType === 'subscription'
          ? item.selling_plan_allocation?.selling_plan?.id
          : eligibleProductType === 'one_time'
            ? !item.selling_plan_allocation?.selling_plan?.id
            : true
      );
  } else {
    isEligible = (item) => eligibleProductIds.includes(item.product_id) &&
      (
        eligibleProductType === 'subscription'
          ? item.selling_plan_allocation?.selling_plan?.id
          : eligibleProductType === 'one_time'
            ? !item.selling_plan_allocation?.selling_plan?.id
            : true
      );
  }

  eligibleProductCount = asyncCart.items?.reduce(
    (sum, item) => isEligible(item) ? sum + item.quantity : sum,
    0
  );

  eligibleProductCount += tandemCount;

  const requiredGiftQuantity = onePerEligible ? eligibleProductCount : (eligibleProductCount > 0 ? 1 : 0);

  if (
    !giftEnable || isRemoved ||
    (giftVariantIds && !giftProductAvailable)
  ) {
    if (hasFreeGift) {
    const giftVariantIdToRemove = asyncCart.items?.find((i) => giftVariantIds.includes(i.variant_id) && i.properties._isGWP).variant_id;
    console.log('Removing gift variant id: asyncCart.items', asyncCart.items);
    console.log('Removing gift variant id:', giftVariantIdToRemove);
    cartAjaxFetch(routes.cart_change_url, giftVariantIdToRemove, totalGiftQuantity - giftQuantity, callback);
    } else if (typeof callback === 'function' && !callbackOnlyOnSuccess) {
      callback();
    }
  } else if (
    giftEnable &&
    eligibleProductIds &&
    giftVariantIds &&
    giftProductAvailable
  ) {
    var cartTotalPrice = asyncCart.items?.reduce((sum, item) => isEligible(item) ? sum + item.final_line_price : sum, 0);
    var cartCurrency = asyncCart.currency;
    var cartTotalPrice__US_Dollar = (window.Currency && typeof window.Currency.convert === 'function')
      ? window.Currency.convert(cartTotalPrice, cartCurrency, 'USD')
      : cartTotalPrice; // fallback if conversion utility is unavailable

    if (
      totalGiftQuantity < requiredGiftQuantity &&
      cartTotalPrice__US_Dollar >= minCartPrice
    ) {
      if (
        eligibleProductIds === 'all-products' ||
        asyncCart.items?.map((item) => item.product_id).some((product_id) => eligibleProductIds.includes(product_id) || 
        tandemCount > 0
      )
      ) {
        if (giftVariantIds.length > 1 && GWPPopup && !giftForcedVariantId) {
          GWPPopup.openGwpPopup(callback);
        } else {
          const giftVariantId = giftForcedVariantId ? giftForcedVariantId : giftVariantIds[0];
          console.log('Adding gift variant id:', giftVariantId);
          cartAjaxFetch(routes.cart_add_url, giftVariantId, giftQuantity, callback, { _isGWP: true });
        }
      } else if (typeof callback === 'function' && !callbackOnlyOnSuccess) {
        callback();
      }
    } else if (
      totalGiftQuantity > requiredGiftQuantity ||
      (totalGiftQuantity > 0 && cartTotalPrice__US_Dollar < minCartPrice) ||
      (asyncCart.items?.length === 1 && asyncCart.items[0].quantity == 1 && hasFreeGift) || 
      (eligibleProductIds != 'all-products' && asyncCart.items?.map((item) => item.product_id).every((product_id) => product_id == giftProductId || !eligibleProductIds.includes(product_id)) && tandemCount == 0)
    ) {
      const giftVariantId = asyncCart.items.find((item) => giftVariantIds.includes(item.variant_id) && item.properties._isGWP)?.variant_id;
      if (!giftVariantId) { if (typeof callback === 'function') callback(); return; }
      cartAjaxFetch(routes.cart_change_url, giftVariantId, totalGiftQuantity - giftQuantity, callback);
    } else if (typeof callback === 'function' && !callbackOnlyOnSuccess) {
      callback();
    }
  } else if (typeof callback === 'function' && !callbackOnlyOnSuccess) {
    callback();
  }
};

async function getCart() {
  const result = await fetch('/cart.json');
  if (result.status === 200) {
      return result.json();
  }
  throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

function cartAjaxFetch(url, id, quantity, callback, properties = null) {

    if (id == null) {
        console.warn('[GWP] cartAjaxFetch called without an id', { url, quantity, properties });
        if (typeof callback === 'function') callback();
        return;
    }

  var body = {
    id: id.toString(),
    quantity: quantity
  };

  if (properties) {
    body.properties = properties;
  }

  body = JSON.stringify(body);

  fetch(url, { ...fetchConfig(), ...{ body } })
  .then((response) => response.json())
  .then((response) => {
    if (response.status) return;
    callback(response);
  }).catch((e) => {
    console.error(e);
  });
}